export default __webpack_public_path__ + "static/media/you-nodat.a14d2418.svg";